import { Badge } from '@mantine/core'
import { DeviceLogLevel } from '@/types/device'

const LEVEL_COLORS: Record<DeviceLogLevel, string> = {
  info: 'blue',
  warning: 'yellow',
  error: 'red',
  critical: 'grape',
  debug: 'gray'
}

type DeviceLogLevelBadgeProps = {
  level: DeviceLogLevel
}

export const DeviceLogLevelBadge = ({ level }: DeviceLogLevelBadgeProps) => {
  return (
    <Badge color={LEVEL_COLORS[level]} variant="light" size="xs">
      {level}
    </Badge>
  )
}
